<div [class.filter-has-no-matching-items]="! state?.canRefine">
    <div *ngIf="control && state"
         class="size-range"
    >
        <div class="size-range__input-container">
            <input type="number"
                   [min]="state.range.min ?? 0"
                   [formControl]="minInput"
                   class="size-range__input"
            />

            <span class="size-range__unit">{{ unit }}</span>
        </div>

        <div class="size-range__input-container">
            <input type="number"
                   [max]="state.range.max ?? 0"
                   [formControl]="maxInput"
                   class="size-range__input"
            />

            <span class="size-range__unit">{{ unit }}</span>
        </div>

        <app-range-slider [control]="control"
                          [connect]="[false, true, false]"
                          [min]="state.range.min ?? 0"
                          [max]="state.range.max ?? 0"
                          [labelFormat]="labelFormatter"
                          [animate]="false"
                          [step]="1"
                          (valueChanges)="valueChange()"
                          [showTooltip]="false"
        ></app-range-slider>
    </div>
</div>
